export const EDITOR_QUERY_LIMIT = 100000;
export const EDITOR_READ_ONLY_LIMIT = 50000;
export const EDITOR_SYNTAX_FEATURES_LIMIT = 30000;
